import { GetActivityLogsState } from 'store/reducers/activity-log/get-activity-logs/types';
import { GET_GUEST_ACTIVITY_LOGS_FAILURE, GET_GUEST_ACTIVITY_LOGS_REQUEST, GET_GUEST_ACTIVITY_LOGS_SUCCESS, GetGuestActivityLogsActionTypes } from './types';

const defaultState: GetActivityLogsState = {
  isLoading: false,
  errorMessage: '',
};

export default function getActivityLogs(state = defaultState, action: GetGuestActivityLogsActionTypes): GetActivityLogsState {
  switch (action.type) {
    case GET_GUEST_ACTIVITY_LOGS_REQUEST:
      return { ...state, isLoading: true };
    case GET_GUEST_ACTIVITY_LOGS_SUCCESS:
      return { ...state, contents: action.contents, isLoading: false, errorMessage: '' };
    case GET_GUEST_ACTIVITY_LOGS_FAILURE:
      return { ...state, isLoading: false, errorMessage: '' };
    default:
      return state;
  }
}
